import { render } from "./TwilioSetting.vue?vue&type=template&id=2aa51816"
import script from "./TwilioSetting.vue?vue&type=script&lang=js"
export * from "./TwilioSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__